module.exports = __webpack_public_path__ + "img/apleshorle.15ad27e1.png";